<script setup lang="ts">
const { url, title = "Aschehoug Video", autoplay = false } = defineProps<{
  url: string;
  title?: string;
  autoplay?: boolean;
}>();

const src = computed(() => {
  const embed = url?.replace("watch?v=", "embed/");
  return embed ? `${embed}?autoplay=${autoplay ? 1 : 0}` : "";
});
</script>

<template>
  <UArticleContainer
    as="section"
    class="aspect-video w-full [--ui-container-inline-padding:0]"
  >
    <iframe
      v-if="url"
      class="size-full"
      :src="src"
      :title="title"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowfullscreen
    />
  </UArticleContainer>
</template>
